import { isFlagEnabled } from "js/utilities";

import { deletePaymentProfile as deprecatedDeletePaymentProfile } from "./deletePaymentProfile.js";
import { deletePaymentProfileApi as releasingDeletePaymentProfile } from "./deletePaymentProfileApi.js";

export default isFlagEnabled("ENABLE_RECURRING_PAYMENTS")
  ? releasingDeletePaymentProfile
  : deprecatedDeletePaymentProfile;
